import { useState, useEffect } from "react";
import { selectors } from "@ReduxStore/reducers";
import actions from "@Src/redux/rootActions";
import { useSelector, useDispatch } from "react-redux";
import API from "@Src/api";

const { addImageLoadFailures } = actions.general;
export const IMAGE_FAILURE_LIMIT = 5;

export function useTrackImageLoadFailure() {
  const imageLoadErrors = useSelector(selectors.getImageLoadErrors);
  const dispatch = useDispatch();
  const handleImageLoadError = (source, placement) => {
    if (!source || !placement) {
      return;
    }
    if (imageLoadErrors.length < IMAGE_FAILURE_LIMIT) {
      dispatch(addImageLoadFailures({ source, placement }));
    }
  };

  return { handleImageLoadError };
}

export function useLogImageLoadErrors() {
  const imageLoadErrors = useSelector(selectors.getImageLoadErrors);
  const [hasSentLog, setHasSentLog] = useState(false);

  useEffect(() => {
    if (!hasSentLog && imageLoadErrors.length >= IMAGE_FAILURE_LIMIT) {
      API.logging.logMessage(imageLoadErrors, "IMAGE_LOAD_FAILURE");
      setHasSentLog(true);
    }
  }, [imageLoadErrors, hasSentLog, setHasSentLog]);
}
